import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  // 🔑 Re-lire le user depuis localStorage (source de vérité)
  let currentUser = user;
  let freshUser = null;
  try {
    const stored = localStorage.getItem('user');
    if (stored) freshUser = JSON.parse(stored);
  } catch (e) {
    freshUser = null;
  }

  // Priorité : localStorage > contexte
  if (freshUser && freshUser.id) {
    currentUser = freshUser;
  }

  // 1. Attendre le chargement du contexte
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#0A0A0A]">
        <div className="text-white text-lg">Chargement...</div>
      </div>
    );
  }

  // 2. Pas authentifié → /login
  const token = localStorage.getItem('token');
  if (!isAuthenticated || !token || !currentUser) {
    return <Navigate to="/login" replace />;
  }

  // 3. Doit changer son mot de passe → /change-password
  // ⚠️ On ne le fait QUE si on n'est PAS déjà sur /change-password
  if (
    currentUser.must_change_password === true &&
    location.pathname !== '/change-password'
  ) {
    return <Navigate to="/change-password" replace />;
  }

  // 4. Rôle non autorisé → rediriger vers SON dashboard
  if (roles && roles.length > 0 && !roles.includes(currentUser.role)) {
    const homeByRole = {
      super_admin: '/super-admin',
      admin: '/admin',
      teacher: '/teacher',
      principal_teacher: '/teacher',
      student: '/student',
      parent: '/parent',
    };
    return <Navigate to={homeByRole[currentUser.role] || '/login'} replace />;
  }

  // 5. Tout est OK
  return children;
};

export default ProtectedRoute;